import React, { useEffect, useState, useCallback, useRef } from 'react';
import './Menu.css';
import { useSelector, useDispatch } from 'react-redux';
import { setActiveMenuItem } from '../../store/menuSlice.js'; // Importujemy akcję do aktualizacji aktywnego linku
import { clearTokens } from '../../store/tokensSlice.js';
import MenuButton from './menuButton.jsx';

import { ReactComponent as HomeHashtag } from '../icons/home-hashtag.svg';
import { ReactComponent as Ticket } from '../icons/ticket.svg';
import { ReactComponent as PersonalCard } from '../icons/personalcard.svg';
import { ReactComponent as People } from '../icons/people.svg';
import { ReactComponent as StatusUp } from '../icons/status-up.svg';
import { ReactComponent as Cup } from '../icons/cup.svg';
import { ReactComponent as Logout } from '../icons/logout.svg';
import { ReactComponent as Settings } from '../icons/settings.svg';
import { ReactComponent as UserSquare } from '../icons/user-square.svg';
import { ReactComponent as UserEdit } from '../icons/user-edit.svg';
import { ReactComponent as MapenLogo } from '../icons/logo.svg';

import { useLocation, Link, useNavigate } from 'react-router-dom';
import SettingsModal from './settingsModal.jsx';

function Menu() {
  const location = useLocation();
  const navigate = useNavigate();
  const activeLink = useSelector((state) => state.menu.activeMenuItem); // Pobranie aktywnego linku z Redux  
  const dispatch = useDispatch();
  const userMenuRef = useRef(null);

  // Stan dla modali
  const [isSettingsModalOpen, setSettingsModalOpen] = useState(false);
  const [isUserMenuOpen, setUserMenuOpen] = useState(false);

  const handleLinkClick = useCallback((path) => {
    dispatch(setActiveMenuItem(path)); // Aktualizacja aktywnego linku w Redux
  }, [dispatch]);

   // Wywołanie handleLinkClick przy pierwszym ładowaniu
   useEffect(() => {
    handleLinkClick(location.pathname); // Wywołanie funkcji z aktualną ścieżką
  }, [location.pathname, handleLinkClick]); // Uruchomienie efektu, gdy zmieni się ścieżka

  const handleLogoutClick = () => {
    dispatch(clearTokens()); // Ustawienie tokenu dostępu na pusty
    window.location.reload(); // Odświeżenie strony po wylogowaniu
  };

  const menuItems = [
    { path: '/', icon: HomeHashtag, label: 'Start' },
    { path: '/events', icon: Ticket, label: 'Wydarzenia' },
    { path: '/organizers', icon: PersonalCard, label: 'Organizatorzy' },
    { path: '/users', icon: People, label: 'Użytkownicy' },
    { path: '/promo', icon: Cup, label: 'Promowanie wydarzeń' },
    { path: '/statistics', icon: StatusUp, label: 'Statystyki' },
  ];

  useEffect(() => {
    if (!isUserMenuOpen) return undefined;

    const handleClickOutside = (event) => {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
        setUserMenuOpen(false);
      }
    };

    const handleEsc = (event) => {
      if (event.key === 'Escape') {
        setUserMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEsc);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEsc);
    };
  }, [isUserMenuOpen]);

  useEffect(() => {
    setUserMenuOpen(false);
  }, [location.pathname]);

  const handleOpenProfileEdit = () => {
    setUserMenuOpen(false);
    handleLinkClick('/users');
    navigate('/users', {
      state: {
        openOwnProfileEdit: true,
      },
    });
  };

  const handleOpenSettings = () => {
    setUserMenuOpen(false);
    setSettingsModalOpen(true);
  };

  const handleLogoutFromMenu = () => {
    setUserMenuOpen(false);
    handleLogoutClick();
  };

  return (
    <div className="menu">
      <div className="menu-content">
        {/* Logo po lewej stronie - klikalne, prowadzi do strony startowej */}
        <Link to="/" className="menu-logo" onClick={() => handleLinkClick('/')}>
          <MapenLogo className="menu-icon-without-text" />
        </Link>

        {/* Środkowy div z wyśrodkowanymi dziećmi */}
        <div className="menu-center">
          {menuItems.map((item) => (
            <MenuButton
              key={item.path}
              path={item.path}
              currentPath={activeLink}
              onClick={handleLinkClick}
              icon={item.icon}
              label={item.label}
              showLabel={true}
              showSpeechBubble={true}
            />
          ))}
        </div>

        {/* Prawy div */}
        <div className="menu-right">
          <div className="profile-menu-container" ref={userMenuRef}>
            <button
              type="button"
              className="menu-profile-trigger menu-item border-gray-L"
              onClick={() => setUserMenuOpen((previous) => !previous)}
              aria-haspopup="menu"
              aria-expanded={isUserMenuOpen}
              aria-label="Menu profilu"
            >
              <UserSquare className="menu-icon-without-text" />
            </button>

            {isUserMenuOpen && (
              <div className="menu-profile-dropdown" role="menu" aria-label="Opcje profilu">
                <button
                  type="button"
                  className="menu-profile-dropdown-item"
                  onClick={handleOpenProfileEdit}
                  role="menuitem"
                >
                  <UserEdit className="menu-profile-dropdown-icon" />
                  <span>Edycja profilu</span>
                </button>
                <button
                  type="button"
                  className="menu-profile-dropdown-item"
                  onClick={handleOpenSettings}
                  role="menuitem"
                >
                  <Settings className="menu-profile-dropdown-icon" />
                  <span>Zmień hasło</span>
                </button>
                <button
                  type="button"
                  className="menu-profile-dropdown-item"
                  onClick={handleLogoutFromMenu}
                  role="menuitem"
                >
                  <Logout className="menu-profile-dropdown-icon" />
                  <span>Wyloguj się</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

        {isSettingsModalOpen && (
            <SettingsModal
                onClose={() => setSettingsModalOpen(false)}
            />
        )}
    </div>
  );
}

export default Menu;
